import styled from "styled-components";

export const MessageDisplay = styled.article`
  text-align: center;
  margin: 88px auto 68px;
`;